export default __webpack_public_path__ + "static/media/form_icon.2800cf8e.svg";